import { Component, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PermissionNode } from '../permission-tree.component';

@Component({
  selector: 'app-permission-node',
  standalone: true,
  imports: [CommonModule, FormsModule, PermissionNodeComponent],
  templateUrl: './permission-node.component.html',
  styleUrl: './permission-node.component.css'
})
export class PermissionNodeComponent {
  @Input() node!: PermissionNode;
  @Output() toggleExpand = new EventEmitter<PermissionNode>();
  @Output() toggleSelection = new EventEmitter<PermissionNode>();

  onToggleExpand(): void {
    this.toggleExpand.emit(this.node);
  }

  onToggleSelection(): void {
    this.toggleSelection.emit(this.node);
  }
}
